<nz-card [nzCover]="coverTemplate" [nzActions]="media.kind === 'image' ? (incidentStatusId < 10 ? [actionWorkReport, actionTogglePow] : [actionTogglePow]) : (incidentStatusId < 10 ? [actionWorkReport] : [])" class="document-tile">
    <nz-card-meta
        [nzDescription]="document.description"
    ></nz-card-meta>
</nz-card>

<ng-template #coverTemplate>
    <div class="document-cover">
        @if (media.kind !== 'image') {
            <a [href]="document.url" target="_blank" rel="noopener noreferrer" class="pdf-icon-container">
                <nz-icon [nzType]="isPdf() ? 'file-pdf' : 'file'" nzTheme="twotone" [nzTwotoneColor]="'#ff4d4f'" class="pdf-icon"></nz-icon>
                <div class="pdf-label">{{ isPdf() ? 'PDF Document' : 'Document' }} — Open / download</div>
            </a>
        } @else {
            <div class="image-container">
                <img nz-image [nzSrc]="document.url" [alt]="document.description || 'Document'" class="document-image" />
                @if (incidentId !== 0) {
                    <button nz-button nzType="primary" nzShape="circle" class="whatsapp-button" (click)="onClickSendPhoto()" [nzLoading]="isSendingPhoto" [disabled]="isSendingPhoto"
                        [title]="photoQueued ? 'Queued for your WhatsApp' : 'Send to my WhatsApp'" [attr.aria-label]="photoQueued ? 'Queued for your WhatsApp' : 'Send to my WhatsApp'">
                        <nz-icon [nzType]="photoQueued ? 'check' : 'whats-app'" nzTheme="outline"></nz-icon>
                    </button>
                }
            </div>
        }
        @if (canRemove) {
            <button nz-button nzType="primary" nzShape="circle" nzDanger class="remove-button" (click)="onClickRemoveDocument()" title="Remove document">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
            </button>
        }
    </div>
</ng-template>

<ng-template #actionWorkReport>
    <button nz-button nzType="text" nzBlock (click)="onClickAssignWorkReport(document.documentId)">
        <nz-icon nzType="file-word" nzTheme="outline" /> Work Report
    </button>
</ng-template>

<ng-template #actionTogglePow>
    <div class="pow-toggle-action">
        <nz-switch [ngModel]="isPowEnabled" (ngModelChange)="onTogglePow($event)" [nzLoading]="isTogglingPow" nzSize="small"></nz-switch>
        <span>Display on POW</span>
    </div>
</ng-template>
